import { Component, OnInit, Input,ViewContainerRef} from '@angular/core';
import { PersonService } from '../../services/person.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { TechnicalserviceService } from '../../../technicalservice/services/technicalservice.service';
import { PurchaseProductService } from '../../../purchase/services/purchase-product.service';
import { RepurchaseProductService } from '../../../repurchase/services/repurchase-product.service';
import { RepurchaseRenewalService } from '../../../repurchase/services/repurchase-renewal.service';
import { ConsignmentProductService } from '../../../consignment/services/consignment-product.service';
import { PurchaseService } from '../../../purchase/services/purchase.service';
import { RepurchaseService } from '../../../repurchase/services/repurchase.service';
import { ConsignmentService } from '../../../consignment/services/consignment.service';
import { ProductService } from '../../../products/services/product.service';
import { UserService } from '../../../common/services/user.service';


import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';

@Component({
  selector: 'app-view-person',
  templateUrl: './view-person.component.html',
  styleUrls: ['./view-person.component.css'],
  providers: [PersonService,TechnicalserviceService, PurchaseProductService,RepurchaseProductService,ConsignmentProductService, 
    PurchaseService,RepurchaseService,ConsignmentService,RepurchaseRenewalService,ProductService, UserService]
})
export class ViewPersonComponent implements OnInit{
    id: number = undefined;
    private sub: any;
    person: any = {}; 
    webcam: any;//will be populated by ack-webcam [(ref)]
    media:any;
    showCamera: any = false;
    expirationDateToast:any;
    bornDateToast:any;
    purchases = [];
    repurchases = [];
    consignments = [];
    technicalservices = [];
    purchasePage: number = 1;
    repurchasePage: number = 1;
    consignmentPage: number = 1;
    technicalservicePage: number = 1;
    purchaseTotalItems: number = 0;
    repurchaseTotalItems: number = 0;
    consignmentTotalItems: number = 0;
    technicalserviceTotalItems: number = 0;
    role:number = 3;
    repurchasePlatformPassword: string = null;

    constructor(private personService: PersonService,private route: ActivatedRoute, private router: Router,public toastr: ToastsManager, vcr: ViewContainerRef,
                private technicalserviceService: TechnicalserviceService, private purchaseProductService:PurchaseProductService,
                private repurchaseProductService: RepurchaseProductService, private consignmentProductService:ConsignmentProductService,private purchaseService:PurchaseService,
                private repurchaseService: RepurchaseService, private consignmentService:ConsignmentService, private repurchaseRenewalService:RepurchaseRenewalService,
                private productService:ProductService, private userService: UserService) {
      this.toastr.setRootViewContainerRef(vcr);
    }
    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            if (params['id'] !== undefined){
                this.id = params['id'];
                this.getPerson();
                this.getPurchases();
                this.getRepurchases();
                this.getConsignments();
                this.getTechnicalServices();
            }
        });
        try{
          this.role = JSON.parse(localStorage.getItem('user')).role;  
        }catch(e){
        }
    }
   
  
    returnProperties(person){
      var properties = {
        nif: person.nif,
        name: person.name,
        surname: person.surname,
        nif_expiration_date: person.nif_expiration_date,
        born_date: person.born_date,
        address: person.address,
        cp: person.cp,
        town: person.town,
        state: person.state,
        telephone: person.telephone,
        mobile: person.mobile,
        email: person.email,
        warning: person.warning
      }
      if (person.id){
        properties['id'] = person.id;
      }
      return properties;
    }
  
  
    getPerson(){
      this.person = {};
      this.personService.get(this.id)
      .subscribe((person) => {
          person.born_date = this.getDate(person.born_date);
          person.nif_expiration_date = this.getDate(person.nif_expiration_date);
          person.naturalCreatedAt = moment(person.createdAt).format("DD-MM-YYYY HH:mm");
          this.person = person;
          if (this.person.warning){
            this.toastr.warning(this.person.warning, '¡Alerta!', {dismiss: "controlled",showCloseButton:true});
          }
          if (moment(this.person.nif_expiration_date).isBefore(moment())){
            this.toastr.warning('DNI caducado', '¡Fecha de caducidad del DNI!', {dismiss: "controlled",showCloseButton:true});
          }
      });
    }
  
    save(){
      if (this.person.id == undefined){
        this.personService.create(this.returnProperties(this.person))
        .subscribe((person) => {
          this.saveUser(_.cloneDeep(this.person.user), person);
          this.getPerson();
        });
      }else{
        this.personService.update(this.returnProperties(this.person))
        .subscribe((person) => {
            this.saveUser(_.cloneDeep(this.person.user), person);
            this.getPerson();
        });
      }
    }

    saveUser(user, person){
      if (user == undefined && this.repurchasePlatformPassword){
        if (this.repurchasePlatformPassword.length >= 6){
          let newUser = {
            username: person.nif,
            name: person.name,
            surname: person.surname,
            role: 4,
            password: this.repurchasePlatformPassword
          };
          this.userService.create(newUser)
          .subscribe((user) => {
            this.personService.update({id: person.id, user_id: user.id})
            .subscribe((person) => {
              this.getPerson();
            });
          });
        }else{
          this.toastr.error('Longitud de contraseña', 'La Contraseña debe tener una longitud de al menos 6 caracteres para la plataforma de renovaciones',{toastLife:2000});
        }
      }else{
        if (user && this.repurchasePlatformPassword){
          if (this.repurchasePlatformPassword.length >= 6){
            user.password = this.repurchasePlatformPassword;
            this.userService.update(user)
            .subscribe((user) => {
              this.getPerson();
            });
          }else{
            this.toastr.error('Longitud de contraseña', 'La Contraseña debe tener una longitud de al menos 6 caracteres para la plataforma de renovaciones',{toastLife:2000});
          }
        }
      }
  }

    getDate(date){
      if (date){
        date = new Date(date);
        let month = (date.getMonth()+1) < 10? '0'+(date.getMonth()+1):(date.getMonth()+1);
        let day = date.getDate() < 10? '0'+date.getDate():date.getDate();
        return date.getFullYear() + "-" + month + '-' + day;
      }else{
        return null;
      }
    }

    checkNifExpirationDate(){
      if(this.expirationDateToast){this.toastr.dismissToast(this.expirationDateToast);}
      if (moment(this.person.nif_expiration_date).isBefore(moment())){
        this.toastr.warning('La fecha proporcionada es anterior a hoy', '¡Fecha de caducidad del DNI!', {dismiss: "controlled",showCloseButton:true}).then((toast)=>{this.expirationDateToast = toast;});
      }
    }
  
    checkBornDate(){
      if(this.bornDateToast){this.toastr.dismissToast(this.bornDateToast);}
      if (moment().diff(moment(this.person.born_date), 'years') < 18){
        this.toastr.warning('Menor de 18 años', '¡Fecha de nacimiento!', {dismiss: "controlled",showCloseButton:true}).then((toast)=>{this.bornDateToast = toast;});
      }
    }

    getPurchases(){
      let params = {
        person:this.id,
        sort: 'id DESC',
        skip: (this.purchasePage-1)*10,
        limit: 10
      };
      this.purchaseService.query(params)
      .subscribe((purchases) => {
        this.purchases = purchases;
        this.purchaseService.count({person:this.id})
        .subscribe((count) => {
          this.purchaseTotalItems = count.count;
        });
        this.getPurchasesProducts();
      });
    }

    getPurchasesProducts(){
      let params = {
        where: {
          purchase_id: this.purchases.map(e => e.id)
        }
      }
      this.purchaseProductService.query(params)
      .subscribe((purchaseProducts) => {
         let groupedPurchaseProducts = _.groupBy(purchaseProducts, (element)=> {return element.purchase.id})
         this.purchases.forEach( (p) =>{
           if (groupedPurchaseProducts[p.id] && groupedPurchaseProducts[p.id].length > 0){
            this.parseProductsDescription(p, groupedPurchaseProducts[p.id]);
           }
         });
       });
    }

    getNameProductType(type){
      var productType= ["Móviles y Tablets","Consolas","Artículos Varios","PC's-portátiles"];
      return productType[type-1];
    }

    getNameSubType(subType, type){
      let subTypes = ["",""];  
      if (type == 1){
        subTypes =["Móvil","Tablet"];
      }else if (type == 4){
        subTypes =["PC","Portatil"];
      }
      return subTypes[subType-1];
    }

    parseProductsDescription(element, groupedProducts){
      element.productDescription = "";
      groupedProducts.forEach(products=>{
        if ((products.product.type!="1" && products.product.type!="4") || ((products.product.type=="1" || products.product.type=="4") && !products.product.sub_type)){
          element.productDescription += this.getNameProductType(products.product.type)+"- ";
        }
       if ((products.product.type=="1" || products.product.type=="4") && products.product.sub_type){
          element.productDescription += this.getNameSubType(products.product.sub_type,products.product.type)+"- ";
        }
        if (products.product.brand){
          element.productDescription += "Marca:"+products.product.brand+", ";
        }
        if (products.product.model){
          element.productDescription += "Modelo:"+products.product.model+", ";
        }
        if (products.product.telephone_company){
          element.productDescription += "Compañia:"+products.product.telephone_company+", ";
        }
        if (products.product.storage_capacity){
          element.productDescription += "Capacidad:"+products.product.storage_capacity+", ";
        }
        if (products.product.status){
          element.productDescription += "Estado:"+products.product.status+", ";
        }
        if (products.product.imei){
          element.productDescription += "Imei:"+products.product.imei+", ";
        }
        if (products.product.imei2){
          element.productDescription += "Imei2:"+products.product.imei2+", ";
        }
        if (products.product.serial_number){
          element.productDescription += "Número de serie:"+products.product.serial_number+", ";
        }
        if (products.product.so){
          element.productDescription += "Sistema Operativo:"+products.product.so+", ";
        }
        if (products.product.ram){
          element.productDescription += "Ram:"+products.product.ram+", ";
        }
        if (products.product.description){
          element.productDescription += "Descripción:"+products.product.description+", ";
        }
        element.productDescription = element.productDescription .slice(0, -2) + " / ";
      });
    }

    getConsignments(){
      let params = {
        person:this.id,
        sort: 'id DESC',
        skip: (this.consignmentPage-1)*10,
        limit: 10
      };
      this.consignmentService.query(params)
      .subscribe((consignments) => {
        this.consignments = consignments;
        this.consignmentService.count({person:this.id})
        .subscribe((count) => {
          this.consignmentTotalItems = count.count;
        });
        this.getConsigmentProducts();
      });
    }

    getConsigmentProducts(){
      let params = {
        where: {
          consignment_id: this.consignments.map(e => e.id)
        }
      }
      this.consignmentProductService.query(params)
      .subscribe((consignmentsProducts) => {
         let groupedConsignmentProducts = _.groupBy(consignmentsProducts, (element)=> {return element.consignment.id})
         this.consignments.forEach( (p) =>{
           if (groupedConsignmentProducts[p.id] && groupedConsignmentProducts[p.id].length > 0){
            this.parseProductsDescription(p, groupedConsignmentProducts[p.id]);
           }
         });
       });
    }

    getRepurchases(){
      let params = {
        person:this.id,
        sort: 'id DESC',
        skip: (this.repurchasePage-1)*10,
        limit: 10
      };
      this.repurchaseService.query(params)
      .subscribe((repurchases) => {
        this.repurchases = repurchases;
        this.repurchaseService.count({person:this.id})
        .subscribe((count) => {
          this.repurchaseTotalItems = count.count;
        });
        this.getRepurchasesProducts();
        this.getRepurchaseRenewals();
      });
    }

    getRepurchasesProducts(){
      let params = {
        where: {
          repurchase_id: this.repurchases.map(e => e.id)
        }
      }
      this.repurchaseProductService.query(params)
      .subscribe((repurchaseProducts) => {
         let groupedRepurchaseProducts = _.groupBy(repurchaseProducts, (element)=> {return element.repurchase.id})
         this.repurchases.forEach( (p) =>{
           if (groupedRepurchaseProducts[p.id] && groupedRepurchaseProducts[p.id].length > 0){
            this.parseProductsDescription(p, groupedRepurchaseProducts[p.id]);
           }
         });
       });
    }

    getRepurchaseRenewals(){
      let params ={
        repurchase: this.repurchases.map(e => e.id)
      }
      this.repurchaseRenewalService.query(params).subscribe((repurchaseRenewals) =>{
        let groupedRepurchaseProducts = _.groupBy(repurchaseRenewals, (element)=> {return element.repurchase.id});
        this.repurchases.forEach((repurchase)=>{
          this.checkIfRepurchaseIsOutOfdateOrValid(repurchase, groupedRepurchaseProducts[repurchase.id]);
        });
      });
  }

  checkIfRepurchaseIsOutOfdateOrValid(repurchase,repurchaseRenewals){
    repurchaseRenewals = !repurchaseRenewals? repurchaseRenewals=[]:repurchaseRenewals;
    if (repurchase.status == "Vigente"){
      if (moment().isAfter(moment(repurchase.due_date)) && 
          (repurchaseRenewals.length == 0 || moment().isAfter(moment(repurchaseRenewals[repurchaseRenewals.length -1].due_date))) ){
          repurchase.status = "Fuera de fecha";
      }
    }else if (repurchase.status == "Fuera de fecha"){
      if (!moment().isAfter(moment(repurchase.due_date)) || 
      (repurchaseRenewals.length != 0 && !moment().isAfter(moment(repurchaseRenewals[repurchaseRenewals.length -1].due_date))) ){
        repurchase.status = "Vigente";
      }  
    }
  }

  getTechnicalServices(){
    let params = {
      person:this.id,
      sort: 'id DESC',
      skip: (this.technicalservicePage-1)*10,
      limit: 10
    };
    this.technicalserviceService.query(params)
    .subscribe((technicalservices) => {
      this.technicalservices = technicalservices;
      this.technicalserviceService.count({person:this.id})
      .subscribe((count) => {
        this.technicalserviceTotalItems = count.count;
      });
    });
  }

  deletePurchase(id){
    var r = confirm("¿Esta seguro de borrar esta compra?");
    if (r == true) {
      let params = {
        where: {
          purchase_id: id
        }
      }
      this.purchaseProductService.query(params)
      .subscribe((purchaseProducts) => {
        purchaseProducts.forEach((e)=>{
          this.productService.delete(e.product.id).subscribe(()=>{});
          this.purchaseProductService.delete(e.id).subscribe(()=>{});
        });
      });
      this.purchaseService.delete(id).subscribe(()=>{
        this.getPurchases();
      });
    }
  }

  deleteRepurchase(id){
    var r = confirm("¿Esta seguro de borrar esta recompra?");
    if (r == true) {
      let params = {
        where: {
          repurchase_id: id
        }
      }
      this.repurchaseProductService.query(params)
      .subscribe((purchaseProducts) => {
        purchaseProducts.forEach((e)=>{
          this.productService.delete(e.product.id).subscribe(()=>{});
          this.repurchaseProductService.delete(e.id).subscribe(()=>{});
        });
      });
      this.repurchaseService.delete(id).subscribe(()=>{
        this.getRepurchases();
      });
    }
  }

  deleteConsigment(id){
    var r = confirm("¿Esta seguro de borrar esta consigna?");
    if (r == true) {
      let params = {
        where: {
          consignment_id: id
        }
      }
      this.consignmentProductService.query(params)
      .subscribe((purchaseProducts) => {
        purchaseProducts.forEach((e)=>{
          this.productService.delete(e.product.id).subscribe(()=>{});
          this.consignmentProductService.delete(e.id).subscribe(()=>{});
        });
      });
      this.consignmentService.delete(id).subscribe(()=>{
        this.getConsignments();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/person/components/view-person/view-person.component.ts